import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  NzButtonComponent,
  NzButtonShape,
  NzButtonSize,
} from 'ng-zorro-antd/button';
import { NgClass } from '@angular/common';

export type ButtonType = 'primary' | 'danger' | 'secondary';

@Component({
  selector: 'app-main-button',
  standalone: true,
  imports: [NzButtonComponent, NgClass],
  templateUrl: './main-button.component.html',
  styleUrl: './main-button.component.scss',
})
export class MainButtonComponent {
  @Output() clickEvent = new EventEmitter<void>();
  @Input() size: NzButtonSize = 'default';
  @Input() shape: NzButtonShape = 'round';
  @Input() type: ButtonType = 'primary';
  @Input() disabled = false;

  handleClick() {
    this.clickEvent.emit();
  }

  get buttonColorClass() {
    switch (this.type) {
      case 'primary': {
        return 'bg-primary text-white';
      }
      case 'danger': {
        return 'bg-red-500 text-white';
      }
      case 'secondary': {
        return 'bg-lime-500 text-white';
      }
    }
  }
}
